import { InjectionToken } from '@angular/core';

export const POST_AUTH_ROUTE = new InjectionToken<string>('Api service');
